import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import { momentHelper } from '../../report/helpers'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportSummaryInsure extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange==='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.type!=undefined) {
            ReportStore.loadInsureStat(this.props.type,this.props.year,this.props.month,this.props.day,(this.props.viewForm!==undefined?this.props.viewForm:''),(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange==='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.type!=undefined) {
            ReportStore.loadInsureStatRange(this.props.type,this.props.startDate,this.props.endDate,(this.props.viewForm!==undefined?this.props.viewForm:''),(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(type,field) {
        let {data} = this.state
        let sum = 0
        data.forEach((item,index)=>{
          let value = (item[field]!==''&&item[field]!==null&&item[field]!==undefined&&!isNaN(item[field])?item[field]:0)
          sum += (value*1)
        })
        return sum
    }

    // getSummary(field) {
    //     let {data} = this.state
    //     let total = 0
    //     data.forEach((item,index)=> {
    //         total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    //     }) 
    //     return total
    // }
    
    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        let {type} = this.props
        if (data.length===0) {
          return(<tr><td colSpan={type==='emp'?5:17}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            // <tr key={index}>
            //   <td className='text-left'>{type==='insurer'?item.insurer_name:item.owner_name}</td>
            //   <td className='text-center'>{item.finance_count}</td>
            //   <td className='text-right'>{this.getNumberFormat(item.finance_amount)}</td>
            //   <td className='text-center'>{item.received_count}</td>
            //   <td className='text-right'>{this.getNumberFormat(item.received_amount)}</td>
            //   <td className='text-center'>{item.balance_count}</td>
            //   <td className='text-right'>{this.getNumberFormat(item.balance_amount)}</td>
            // </tr>
            <tr key={index}>
              <td className='text-left'>{type==='insurer'?item.insurer_name:type==='emp'?item.work_owner_by:item.owner_name}</td>
              <td className='text-center'>{item.work_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.work_amount)}</td>
              <td className='text-center'>{item.work_approved_count}</td>
              <td className='text-right'>{this.getNumberFormat(item.work_approved_amount)}</td>
              {type==='emp'?'':<td className='text-center'>{item.unprocess_finance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.unprocess_finance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.unprocess_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'>{item.process_finance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.process_finance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.process_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'>{item.received_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.received_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.received_approved_amount)}</td>}
              {type==='emp'?'':<td className='text-center'>{item.balance_count}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.balance_amount)}</td>}
              {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(item.balance_approved_amount)}</td>}
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        let {type} = this.props
        return(
            <table className='table table-print-report-analysis'>
                <tbody>
                    {/* <tr>
                        <td rowSpan={2} className='text-center' style={{width:'200px'}}>{type==='insurer'?'บริษัทประกัน':'เจ้าของ'}</td>
                        <td colSpan={2} className='text-center'>ตั้งเบิก</td>
                        <td colSpan={2} className='text-center'>รับเงินแล้ว</td>
                        <td colSpan={2} className='text-center'>คงเหลือ</td>
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'90px'}}>จ๊อบ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเงิน</td>
                        <td className='text-center' style={{width:'90px'}}>จ๊อบ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเงิน</td>
                        <td className='text-center' style={{width:'90px'}}>จ๊อบ</td>
                        <td className='text-center' style={{width:'90px'}}>จำนวนเงิน</td>
                    </tr> */}
                    <tr>
                        <td rowSpan={2} className='text-center' style={{width:'200px'}}>{type==='insurer'?'บริษัทประกัน':type==='emp'?'พนักงานเจ้าของงาน':'เจ้าของ'}</td>
                        <td colSpan={4} className='text-center'>{type==='emp'?'รายการใบงาน':'งานเสร็จแล้ว'}</td>
                        {type==='emp'?'':<td colSpan={3} className='text-center'>รอตั้งเบิก</td>}
                        {type==='emp'?'':<td colSpan={3} className='text-center'>ตั้งเบิก</td>}
                        {type==='emp'?'':<td colSpan={3} className='text-center'>รับเงินแล้ว</td>}
                        {type==='emp'?'':<td colSpan={3} className='text-center'>รอรับเงิน</td>}
                    </tr>
                    <tr>
                        <td className='text-center' style={{width:'90px'}}>จ๊อบ</td>
                        <td className='text-center' style={{width:'90px'}}>เสนอ</td>
                        <td className='text-center' style={{width:'90px'}}>จ๊อบ</td>
                        <td className='text-center' style={{width:'90px'}}>อนุมัติ</td>
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>จ๊อบ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>เสนอ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>อนุมัติ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>จ๊อบ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>เสนอ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>อนุมัติ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>จ๊อบ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>เสนอ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>อนุมัติ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>จ๊อบ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>เสนอ</td>}
                        {type==='emp'?'':<td className='text-center' style={{width:'90px'}}>อนุมัติ</td>}
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    // <tr>
                    //     <td className='text-right'>ยอดรวมสุทธิ</td>
                    //     <td className='text-center'>{this.getSummary('finance_count')}</td>
                    //     <td className='text-right'>{this.getNumberFormat(this.getSummary('finance_amount'))}</td>
                    //     <td className='text-center'>{this.getSummary('received_count')}</td>
                    //     <td className='text-right'>{this.getNumberFormat(this.getSummary('received_amount'))}</td>
                    //     <td className='text-center'>{this.getSummary('balance_count')}</td>
                    //     <td className='text-right'>{this.getNumberFormat(this.getSummary('balance_amount'))}</td>
                    // </tr>
                    <tr>
                        <td className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary(type,'work_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary(type,'work_amount'))}</td>
                        <td className='text-center'>{this.getNumberFormat(this.getSummary(type,'work_approved_count'),0)}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary(type,'work_approved_amount'))}</td>
                        {type==='emp'?'':<td className='text-center'>{this.getNumberFormat(this.getSummary(type,'unprocess_finance_count'),0)}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'unprocess_finance_amount'))}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'unprocess_approved_amount'))}</td>}
                        {type==='emp'?'':<td className='text-center'>{this.getNumberFormat(this.getSummary(type,'process_finance_count'),0)}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'process_finance_amount'))}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'process_approved_amount'))}</td>}
                        {type==='emp'?'':<td className='text-center'>{this.getNumberFormat(this.getSummary(type,'received_count'),0)}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'received_amount'))}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'received_approved_amount'))}</td>}
                        {type==='emp'?'':<td className='text-center'>{this.getNumberFormat(this.getSummary(type,'balance_count'),0)}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'balance_amount'))}</td>}
                        {type==='emp'?'':<td className='text-right'>{this.getNumberFormat(this.getSummary(type,'balance_approved_amount'))}</td>}
                    </tr>
                  :''}
                </tbody>
            </table>
        )
    }

    getDate() {
        let {day,year,month,isRange,startDate,endDate} = this.props
        if (isRange==='true') {
            return 'ประจำวันที่ '+startDate+' - '+endDate
        } else {
            let text = 'ประจำวันที่ '
            text += day+' '+momentHelper.getMonthText(month)+' '+year
            if (year==='0'||year==='00') {
                text = 'ทั้งหมด'
            } else if (month==='0'||month==='00') {
                text = 'ประจำปี '+year
            } else if (day==='0'||day==='00') {
                text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
            }
          return text
        }  
    }

    renderComponentPage(item,index,length) {
        let {type} = this.props
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{type==='insurer'?this.props.title:type==='emp'?'ตารางรายงานสรุปยอดรายได้พนักงานเสนอราคา (รายเดือน)':'ตารางรายงานสรุปยอดรายได้เงินสด (รายเดือน)'}</h2>
                    <div className='text-center'>
                        {this.getDate()}
                    </div>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
                <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length===0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportSummaryInsure.defaultProps = {
    title:'ตารางรายงานสรุปยอดรายได้ประกัน (รายเดือน)',
    mode:'',
    workNo:'',
    type:'insurer'
  }
  export default PrintReportSummaryInsure;


// WEBPACK FOOTER //
// ./src/view/print/analysis/PrintReportSummaryInsure.js